
const state = {
  active: true,
  calling_code: '',
  code: '',
  currency_code: '',
  currency_symbol: '',
  id: null,
  tax_rate: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
